import React, { CSSProperties, ChangeEvent, useRef } from "react";
import "./OtherSettings.css";
import { colourMap } from "../../../../utils/typesAndMaps";
import ImageTooltip from "../../../ImageTooltip/ImageTooltip";
import { useSelector, useDispatch } from 'react-redux';
import { colourType, updateOtherSettings } from "../../../../store/features/otherSettingsSlice";
import { deepClone } from "../../../../utils/helpers";
import { updateGlobalSettings } from "../../../../store/features/globalSettingsSlice";
import { RootStore } from "../../../../store";
import { updateDialogState } from "../../../../store/features/dialogStatesSlice";

export default function OtherSettings() {
  const otherSettings = useSelector((store: RootStore) => store.otherSettings);
  const globalSettings = useSelector((store: RootStore) => store.globalSettings);

  const manualInput = useRef(false);
  
  const dispatch = useDispatch();

  const styles = {
    "--bc": globalSettings.FurtherModes.inside.DPMCodeReadingModes.value[0] === "DPMCRM_GENERAL" ? "rgb(0,0,0)" : "rgb(204, 204, 204)",
    "--left": globalSettings.FurtherModes.inside.DPMCodeReadingModes.value[0] === "DPMCRM_GENERAL" ? "31px" : "3px",
    "--borderColor": globalSettings.FurtherModes.inside.DPMCodeReadingModes.value[0] === "DPMCRM_GENERAL" ? "rgb(255,255,255)" : "rgb(0,0,0)"
  } as CSSProperties;

  // const changeCount = (e: ChangeEvent<HTMLInputElement>) => {
  //   let value = parseInt(e.target.value);
  //   if (!value || value <= 0) value = 0;
  //   if (value > 999) value = 999;
  //   const copySettings = deepClone(globalSettings);
  //   copySettings.ExpectedBarcodesCount.value = value;
  //   dispatch(updateOtherSettings({ type: "textCount", value: value === 0 ? "auto" : value }))
  //   dispatch(updateGlobalSettings({ settings: copySettings }));
  // }

  const changeDpm = () => {
    const copySettings = deepClone(globalSettings);
    const value = copySettings.FurtherModes.inside.DPMCodeReadingModes.value[0];
    copySettings.FurtherModes.inside.DPMCodeReadingModes.value[0] = value === "DPMCRM_SKIP" ? "DPMCRM_GENERAL" : "DPMCRM_SKIP";
    dispatch(updateGlobalSettings({ settings: copySettings }));
  }

  const changeColour = (option: colourType) => {
    const copySettings = deepClone(globalSettings);
    copySettings.FurtherModes.inside.GrayscaleTransformationModes.value = colourMap[option];
    dispatch(updateOtherSettings({ type: "colour", value: option }));
    dispatch(updateGlobalSettings({ settings: copySettings }));
  }

  const textInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = parseInt(e.target.value);
    if (!value || value <= 0) value = 0;
    if (value > 999) value = 999;
    dispatch(updateOtherSettings({ type: "textCount", value }));
  }

  const blurEvent = () => {
    if (!otherSettings.textCount) dispatch(updateOtherSettings({ type: "textCount", value: "auto" }));
    const textCount = otherSettings.textCount;
    const copySettings = deepClone(globalSettings);
    if(copySettings.ExpectedBarcodesCount.value === otherSettings.textCount) return;
    copySettings.ExpectedBarcodesCount.value = textCount;
    dispatch(updateGlobalSettings({ settings: copySettings }));
    if(!manualInput.current && typeof textCount === "number" && textCount >= 20) {
      dispatch(updateDialogState({ stateName: "isShowDialog", value: true }));
      manualInput.current = true;
    }
  }

  return (
    <div className="dbr-other-settings" style={styles}>
      <div className="dbr-expected-barcode-count">
        <span>Expected Barcode Count</span>
        {/* <input type="range" min="0" max="999" value={globalSettings.ExpectedBarcodesCount.value} autoComplete="off" onChange={changeCount} /> */}
        <input type="text" max="999" style={{marginLeft: "20px"}} value={otherSettings.textCount} autoComplete="off" onChange={textInputChange} onBlur={blurEvent} />
      </div>
      <div className="dbr-direct-part-marking" onClick={changeDpm}>
        <ImageTooltip title="supports-DPM-DataMatrix.gif" tipStyle={{ backgroundColor: "#fff", border: "2px solid #ddd" }}>
          <span>Direct Part Marking (DPM)</span>
        </ImageTooltip>
        <div className="dbr-switch"></div>
      </div>
      <div className="dbr-colour-options">
        <span>Barcode Colour Option</span>
        <div className="dbr-colour-option">
          <ImageTooltip title="normal.gif" containerStyle={{ height: "30px" }} tipStyle={{ top: "25px", backgroundColor: "#fff", border: "2px solid #ddd" }}>
            <div className="dbr-normal">
              <input type="radio" id="dbr-normal" name="dbr-colour" checked={otherSettings.colour === "normal"} onChange={() => { changeColour("normal") }} />
              <label htmlFor="dbr-normal" className="radio-label">Normal</label>
            </div>
          </ImageTooltip>
          <ImageTooltip title="inverted.gif" containerStyle={{ height: "30px" }} tipStyle={{ top: "25px", backgroundColor: "#fff", border: "2px solid #ddd" }}>
            <div className="dbr-inverted">
              <input type="radio" id="dbr-inverted" name="dbr-colour" checked={otherSettings.colour === "inverted"} onChange={() => { changeColour("inverted") }} />
              <label htmlFor="dbr-inverted" className="radio-label">Inverted</label>
            </div>
          </ImageTooltip>
          <ImageTooltip title="both.gif" containerStyle={{ height: "30px" }} tipStyle={{ top: "25px", backgroundColor: "#fff", border: "2px solid #ddd" }}>
            <div className="dbr-both">
              <input type="radio" id="dbr-both" name="dbr-colour" checked={otherSettings.colour === "both"} onChange={() => { changeColour("both") }} />
              <label htmlFor="dbr-both" className="radio-label">Both</label>
            </div>
          </ImageTooltip>
        </div>
      </div>
    </div>
  )
}